import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import * as Sentry from "@sentry/react";

const initialState: { currentChannel: string } = {
  currentChannel: "None",
};

const channelSlice = createSlice({
  name: "channel",
  initialState,
  reducers: {
    setChannel: (state, action: PayloadAction<string>) => {
      state.currentChannel = action.payload;
      Sentry.setTag("channel", action.payload);
    },
  },
});

export const { setChannel } = channelSlice.actions;
export default channelSlice.reducer;
